// extracted by mini-css-extract-plugin
export default {"control":"Poste_control__mvEnX","wrapper":"Poste_wrapper__E6kFO","confirm":"Poste_confirm__7eyHL","price":"Poste_price__p8Qqa"};